

export const wanFeatures = {
    title: '為什麼 Wan 2.5 是最先進的 AI 影片生成器',
    items: [
      { num: '01', title: '原生音訊生成（業界首創）', text: 'Wan 2.5 可同時生成影片與音訊：唇形對齊的同步對白、與畫面節奏匹配的背景音樂、環境聲與氛圍音效。' },
      { num: '02', title: '卓越穩定與連貫運鏡', text: '進階攝影語言帶來平滑轉場與穩定追蹤。專業級運鏡與自然動勢。' },
      { num: '03', title: '彈性時長與多解析度支援', text: '生成 5 秒或 10 秒影片。多種比例：16:9 橫向、9:16 直向、1:1 方形。社群平台優化。' },
      { num: '04', title: '最大創作自由與多元內容', text: '寬鬆內容審核允許大膽、動態創作。支援文字、圖片與音訊參考等多模態輸入，並具優秀多語言支援。' }
    ]
  };
